import { Controller } from '@hotwired/stimulus'
import { createErrorHintElement } from '../utils/dom'

// отображает звезды в зависимости от выбранной оценки

export default class extends Controller {
  static targets = ['star', 'input', 'errors', 'valueNumber']
  static values = {
    required: { type: Boolean, default: false },
    requiredMessage: String
  }

  #errorHintElement = null

  connect() {
    this.selectedRating = this.checkedRating
    this.hoveredRating = 0
    this.updateStars(this.selectedRating)
    this.updateValue(this.selectedRating)
  }

  hover(event) {
    const star = event.currentTarget
    const rating = parseInt(star.dataset.rating, 10)
    this.hoveredRating = rating
    this.element.classList.add('is-hovering')
    this.updateStars(rating)
  }

  leave() {
    this.hoveredRating = 0
    this.element.classList.remove('is-hovering')
    this.updateStars(this.selectedRating)
  }

  select(event) {
    const star = event.currentTarget
    const rating = parseInt(star.dataset.rating, 10)
    this.selectedRating = rating

    // Отмечаем соответствующий radio button
    this.inputTargets.forEach((input) => {
      input.checked = parseInt(input.value, 10) === rating
    })

    this.updateStars(rating)
    this.updateValue(rating)
    this.validate()
  }

  updateValue(rating) {
    if (this.hasValueNumberTarget) {
      this.valueNumberTarget.textContent = rating
    }
  }

  updateStars(rating) {
    this.starTargets.forEach((star) => {
      const starRating = parseInt(star.dataset.rating, 10)
      star.classList.toggle('is-active', starRating <= rating)
      star.classList.toggle('is-hovered', starRating <= this.hoveredRating)
    })
  }

  validate() {
    const errors = []
    this.selectedRating = this.checkedRating

    if (this.requiredValue && this.selectedRating === 0) {
      errors.push(
        this.hasRequiredMessageValue
          ? this.requiredMessageValue
          : 'This field is required'
      )
    }

    this.showErrors(errors)
    return errors.length === 0
  }

  showErrors(errors) {
    const hasErrors = errors.length > 0

    this.element.classList.toggle('is-invalid', hasErrors)

    if (this.#errorHintElement) {
      this.#errorHintElement.remove()
      this.#errorHintElement = null
    }

    if (this.hasErrorsTarget && hasErrors) {
      this.#errorHintElement = createErrorHintElement(
        errors[0],
        this.element.classList.contains('rating--no-inverse')
      )
      this.errorsTarget.appendChild(this.#errorHintElement)
    }
  }

  reset() {
    this.selectedRating = 0
    this.hoveredRating = 0
    this.element.classList.remove('is-hovering')
    this.updateStars(0)
    this.updateValue(0)

    // Снимаем отметку со всех radio buttons
    this.inputTargets.forEach((input) => {
      input.checked = false
    })

    this.element.classList.remove('is-invalid')
    if (this.#errorHintElement) {
      this.#errorHintElement.remove()
      this.#errorHintElement = null
    }
  }

  get checkedRating() {
    const checkedInput = this.inputTargets.find((input) => input.checked)

    if (!checkedInput) return 0

    return parseInt(checkedInput.value, 10)
  }
}
